import * as Styles from './_styles/logo.styled'
import {LogoGroup} from '../../../../pages/login-v2/components/header/LogoGroup'
import {DEFAULT_REDIRECT_URL} from '@/values/default-redirect-url'

import type {JSX} from 'react'

export function Logo(): JSX.Element {
    return (
        <Styles.Logo id="navigation-logo" to={DEFAULT_REDIRECT_URL} aria-label="Medulla dashboard">
            <LogoGroup />
        </Styles.Logo>
    )
}
